var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import { Button, FormControl, FormLabel, Popover, PopoverBody, PopoverCloseButton, PopoverContent, PopoverTrigger, Stack, } from "@chakra-ui/react";
import { AlphaPicker, CompactPicker } from "react-color";
import { FormLabelStyle } from "../../styles";
export const CompactColorPicker = (_a) => {
    var { id, label, color, minimized = false, buttonWidth, onChange } = _a, props = __rest(_a, ["id", "label", "color", "minimized", "buttonWidth", "onChange"]);
    const [colorState, setColorState] = useState(color);
    const [alphaState, setAlphaState] = useState("FF");
    return (React.createElement(FormControl, null,
        label ? (React.createElement(FormLabel, Object.assign({ htmlFor: id }, FormLabelStyle), label)) : (React.createElement(React.Fragment, null)),
        minimized ? (React.createElement(Popover, null,
            React.createElement(PopoverTrigger, null,
                React.createElement(Button, { size: "xs", width: buttonWidth !== null && buttonWidth !== void 0 ? buttonWidth : undefined, backgroundColor: color, variant: "outline" })),
            React.createElement(PopoverContent, null,
                React.createElement(PopoverCloseButton, null),
                React.createElement(PopoverBody, null,
                    React.createElement(Stack, null,
                        React.createElement(CompactPicker, Object.assign({}, props, { color: color, onChangeComplete: (newColor) => {
                                setColorState(newColor.hex);
                                onChange(`${newColor.hex}${alphaState}`);
                            } })),
                        React.createElement(AlphaPicker, { width: "100%", color: color, onChange: (c) => {
                                var _a;
                                const alpha = Math.round(((_a = c.rgb.a) !== null && _a !== void 0 ? _a : 1) * 255)
                                    .toString(16)
                                    .padStart(2, "0");
                                setAlphaState(alpha);
                                onChange(`${colorState}${alpha}`);
                            } })))))) : (React.createElement(Stack, null,
            React.createElement(CompactPicker, Object.assign({}, props, { color: color, onChangeComplete: (newColor) => {
                    setColorState(newColor.hex);
                    onChange(`${newColor.hex}${alphaState}`);
                } })),
            React.createElement(AlphaPicker, { width: "100%", color: color, onChange: (c) => {
                    var _a;
                    const alpha = Math.round(((_a = c.rgb.a) !== null && _a !== void 0 ? _a : 1) * 255)
                        .toString(16)
                        .padStart(2, "0");
                    setAlphaState(alpha);
                    onChange(`${colorState}${alpha}`);
                } })))));
};
